import {NgModule} from '@angular/core';
import {TooltipComponent} from './components/tooltip/tooltip.component';

@NgModule({
  imports: [],
  declarations: [TooltipComponent],
  exports: [TooltipComponent]
})
export class FrameworkModule {
}
